import React from 'react';
import PropTypes from 'prop-types';

function ChevronRight({ className = 'icon-chevron-right', ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      className={className}
      {...props}
    >
      <path d="M4.452 0l-1.26 1.26L9.932 8l-6.74 6.74L4.452 16l8-8-8-8z" />
    </svg>
  );
}

ChevronRight.propTypes = {
  className: PropTypes.string,
};

export default ChevronRight;